
import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
// import data from 'highcharts/modules/data';
import dataGrouping from 'highcharts/modules/datagrouping';
import xrange from 'highcharts/modules/xrange';
import windbarb from 'highcharts/modules/windbarb';
import accessibility from 'highcharts/modules/accessibility';

window.Highcharts = Highcharts;

highchartsMore(Highcharts);
dataGrouping(Highcharts);
xrange(Highcharts);
windbarb(Highcharts);
accessibility(Highcharts);

